import { MediaUpload, MediaUploadCheck } from "@wordpress/block-editor";
import { Button } from "@wordpress/components";
import { __ } from "@wordpress/i18n";
import React from "react";
//@ts-ignore
import placeholderImage from "../../../images/placeholder.png";
import Icon from "../icon/Icon";
import "./editor.scss";

type Props = {
	onChange?: (value: unknown) => void;
	type?: string;
	value?: {
		url?: string;
		[key: string]: string | number | undefined;
	};
	label?: string;
};

const Media: React.FC<Props> = (props) => {
	const { onChange, type = "image", value = {}, label } = props;

	const buttonString = value?.url
		? __("Replace", "magazine-blocks") +
		  " " +
		  ("image" === type ? "Image" : "Video")
		: __("Add", "magazine-blocks") +
		  " " +
		  ("image" === type ? "Image" : "Video");

	const onSelect = (media: {
		url?: string;
		id?: number;
		height?: number;
		width?: number;
		alt?: string;
	}) => {
		if (!media?.url) {
			return;
		}
		const { url, id, height, width, alt } = media;
		onChange?.({ url, id, height, width, alt });
	};

	return (
		<div className="mzb-control mzb-media">
			<div
				className="mzb-control-head mzb-media-head"
				style={{ marginBottom: "12px" }}
			>
				<label htmlFor="mzb-media-head">{label}</label>
			</div>
			<div className="mzb-control-body mzb-media-body">
				<MediaUploadCheck>
					<MediaUpload
						onSelect={onSelect}
						allowedTypes={[type]}
						title={"Upload Image"}
						render={({ open }) => (
							<>
								<div
									className="mzb-media-placeholder mzb-media-preview"
									onClick={open}
									onKeyDown={(e) => "Enter" === e.key && open}
									role="button"
									tabIndex={0}
									title={buttonString}
								>
									<img
										src={value?.url || placeholderImage}
										alt={__(
											"mzb preview image",
											"magazine-blocks"
										)}
									/>
								</div>
								<Button
									className="mzb-media-button"
									onClick={open}
								>
									<Icon
										type="controlIcon"
										name="image"
										size={20}
									/>
									<span className="mzb-media-button-text">
										{buttonString}
									</span>
								</Button>
								{value && (
									<Button
										className="mzb-media-delete"
										onClick={() => onChange?.("")}
									>
										<Icon
											type="controlIcon"
											name="trash"
											size={20}
										/>
									</Button>
								)}
							</>
						)}
					/>
				</MediaUploadCheck>
			</div>
		</div>
	);
};

export default Media;
